import {
	type AggregatedVendorCount,
	DELIVERY_METHOD_KIND,
	type DeliveryMethod,
	type DeliveryMethodKind,
	VENDOR_AGGREGATION_GROUP,
	type VendorListItem,
} from "@dransay/api/models";
import type { TFunction } from "i18next";

export type AggregatedVendorOption = VendorListItem & {
	isGroup: boolean;
	count: number;
	logoKey: string | null;
};

const getTemplateDeliveryMethod = (
	kind: DeliveryMethodKind,
): DeliveryMethod => ({
	uuid: "0",
	kind,
	description: null,
	cost: null,
	freeFrom: null,
	enabled: true,
});

const getAggregatedVendorOptionsForDe = (
	deliveryMethodKind: DeliveryMethodKind | undefined,
	t: TFunction<"product">,
	aggregatedCount?: AggregatedVendorCount,
): AggregatedVendorOption[] => {
	switch (deliveryMethodKind) {
		case DELIVERY_METHOD_KIND.SHIPPING: {
			return [
				{
					id: VENDOR_AGGREGATION_GROUP.TOP,
					name: t("vendor.group.topShipping"),
					deliveryMethods: [
						getTemplateDeliveryMethod(DELIVERY_METHOD_KIND.SHIPPING),
					],
					isGroup: true,
					isTop: true,
					count: aggregatedCount?.top ?? 0,
					contact: null,
					address: null,
					logoUrl: null,
					logoKey: null,
					combinedPaymentEnabled: false,
					deliveryMethodsSchemaVersion: "v0",
				},
				{
					id: VENDOR_AGGREGATION_GROUP.ALL,
					name: t("vendor.group.allShipping"),
					deliveryMethods: [
						getTemplateDeliveryMethod(DELIVERY_METHOD_KIND.SHIPPING),
					],
					isGroup: true,
					isTop: false,
					count: aggregatedCount?.all ?? 0,
					contact: null,
					address: null,
					logoUrl: null,
					logoKey: null,
					combinedPaymentEnabled: false,
					deliveryMethodsSchemaVersion: "v0",
				},
			];
		}
		case DELIVERY_METHOD_KIND.PICKUP: {
			return [
				{
					id: VENDOR_AGGREGATION_GROUP.TOP,
					name: t("vendor.group.topPickup"),
					deliveryMethods: [
						getTemplateDeliveryMethod(DELIVERY_METHOD_KIND.PICKUP),
					],
					isGroup: true,
					isTop: true,
					count: aggregatedCount?.top ?? 0,
					contact: null,
					address: null,
					logoUrl: null,
					logoKey: null,
					combinedPaymentEnabled: false,
					deliveryMethodsSchemaVersion: "v0",
				},
				{
					id: VENDOR_AGGREGATION_GROUP.ALL,
					name: t("vendor.group.allPickup"),
					deliveryMethods: [
						getTemplateDeliveryMethod(DELIVERY_METHOD_KIND.PICKUP),
					],
					isGroup: true,
					isTop: false,
					count: aggregatedCount?.all ?? 0,
					contact: null,
					address: null,
					logoUrl: null,
					logoKey: null,
					combinedPaymentEnabled: false,
					deliveryMethodsSchemaVersion: "v0",
				},
			];
		}
		case DELIVERY_METHOD_KIND.COURIER: {
			return [
				{
					id: VENDOR_AGGREGATION_GROUP.TOP,
					name: t("vendor.group.topCourier"),
					deliveryMethods: [
						getTemplateDeliveryMethod(DELIVERY_METHOD_KIND.COURIER),
					],
					isGroup: true,
					isTop: true,
					count: aggregatedCount?.top ?? 0,
					contact: null,
					address: null,
					logoUrl: null,
					logoKey: null,
					combinedPaymentEnabled: false,
					deliveryMethodsSchemaVersion: "v0",
				},
				{
					id: VENDOR_AGGREGATION_GROUP.ALL,
					name: t("vendor.group.allCourier"),
					deliveryMethods: [
						getTemplateDeliveryMethod(DELIVERY_METHOD_KIND.COURIER),
					],
					isGroup: true,
					isTop: false,
					count: aggregatedCount?.all ?? 0,
					contact: null,
					address: null,
					logoUrl: null,
					logoKey: null,
					combinedPaymentEnabled: false,
					deliveryMethodsSchemaVersion: "v0",
				},
			];
		}
		default: {
			return [];
		}
	}
};

export const getAggregatedVendorOptions = (
	deliveryMethodKind: DeliveryMethodKind | undefined,
	t: TFunction<"product">,
	aggregatedCount?: AggregatedVendorCount,
) => {
	return getAggregatedVendorOptionsForDe(
		deliveryMethodKind,
		t,
		aggregatedCount,
	);
};
